import { Reveal } from '@/components/Reveal';

export default function SectionHead({ eyebrow, title, subtitle, align = 'left', dark = false }) {
  return (
    <div className={`max-w-2xl ${align === 'center' ? 'mx-auto text-center' : ''}`}>
      {eyebrow && (
        <Reveal>
          <span className={`eyebrow ${dark ? 'text-brand-cyan' : ''}`}>
            <span className="h-1.5 w-1.5 rounded-full bg-brand-blue" />
            {eyebrow}
          </span>
        </Reveal>
      )}
      <Reveal delay={0.05}>
        <h2 className={`mt-4 font-display text-3xl font-bold leading-[1.08] tracking-tight sm:text-4xl lg:text-[44px] ${dark ? 'text-white' : 'text-brand-navy'}`}>
          {title}
        </h2>
      </Reveal>
      {subtitle && (
        <Reveal delay={0.1}>
          <p className={`mt-4 text-base leading-relaxed sm:text-lg ${dark ? 'text-white/60' : 'text-brand-muted'}`}>{subtitle}</p>
        </Reveal>
      )}
    </div>
  );
}